import React from "react";
import "./OurNetwork.css";
function OurNetwork() {
  return (
    <React.Fragment>
      <div className="OurNetworkWrapper">
        <div className="OurNetworkHeading">Our Network</div>
        <div className="OurNetworkContent">
          Operating in all the major cities of India with 50,000+ well-trained
          professional drivers, we are committed to help our driver partners
          become micro-entrepreneurs and increase their income. DriveU also
          strives to improve quality of life for its driver partners through
          training in etiquette, hygiene, service quality etc.
        </div>
        <div className="OurNetworkImageDiv">
          <img
            src="https://ik.imagekit.io/driveu/Web/India-image__1__h1kjxnj-U.png"
            alt="India Map"
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
            className="mapDesktopImg"
          />
          <img
            src="https://ik.imagekit.io/driveu/Web/Group__1__wtqUj3ecF.png"
            alt="India Map"
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
            className="mapMobileImg"
          />
        </div>
        <div className="OurNetworkStaticsGridLayout">
          <div className="OurNetworkTextContent">
            <div className="OurNetworkNumber">50K+</div>
            <div className="OurNetworkNumberContent">
              Well-trained & professional Driver Partners
            </div>
          </div>
          <div className="OurNetworkTextContent">
            <div className="OurNetworkNumber">5M+</div>
            <div className="OurNetworkNumberContent">
              Drives completed by professional drivers
            </div>
          </div>
          <div className="OurNetworkTextContent">
            <div className="OurNetworkNumber">650K+</div>
            <div className="OurNetworkNumberContent">
              Car owners served on DriveU apps and website
            </div>
          </div>
          <div className="OurNetworkTextContent">
            <div className="OurNetworkNumber">10+</div>
            <div className="OurNetworkNumberContent">
              Major Indian cities covered by DriveU driver services
            </div>
          </div>
          <div className="OurNetworkTextContent">
            <div className="OurNetworkNumber">7+</div>
            <div className="OurNetworkNumberContent">
              Years of Simplifying Car Ownership
            </div>
          </div>
          <div className="OurNetworkTextContent">
            <div className="OurNetworkNumber">Millions</div>
            <div className="OurNetworkNumberContent">
              Lives saved by encouraging safe after-party drops
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default OurNetwork;
